  let ef_transaction_id_get = '';
  const storedTxId = sessionStorage.getItem('ef_transaction_id');
  if (storedTxId) {
    ef_transaction_id_get = storedTxId;
  }

(function () {

    if (document.cookie.includes('hc-has-account=1')) {

        window.location.href = 'app.humecare.com/get-started'
        
    }else{       

        function formatDateOnLoad(value) {
            if (!value) return '';
            if (/^\d{4}-\d{2}-\d{2}$/.test(value)) return value;
            const date = new Date(value);
            if (isNaN(date.getTime())) return '';
            const yyyy = date.getFullYear();
            const mm   = String(date.getMonth() + 1).padStart(2, '0');
            const dd   = String(date.getDate()).padStart(2, '0');
            return `${yyyy}-${mm}-${dd}`;
        } 

        function getPatientDataOnLoad() {
            return JSON.parse(localStorage.getItem('patient_starter') || '{}');
        }
                
        function initPatientSubmit() {
            const submitted = sessionStorage.getItem('patient_api_submitted');
            if (!submitted) {
                submitPatientDataOnLoad();
            }
        }

        async function submitPatientDataOnLoad() {
            sessionStorage.setItem('patient_api_submitted', 'true');
            const data = getPatientDataOnLoad();
            if (data.first_name && data.first_name.trim() !== '') {
                const payload = {
                    programCode   : 'glp1',
                    offer         : 4,
                    patientStarter: {
                        firstName      : data.first_name    || '',
                        lastName       : data.last_name     || '',
                        email          : data.email         || '',
                        dateOfBirth    : formatDateOnLoad(data.date_of_birth),
                        gender         : data.gender        ?? null,
                        weight         : data.weight        ?? null,
                        height         : data.height        ?? null,
                        address: {
                            address    : data.address?.address    || '',
                            address2   : data.address?.address2   || '',
                            zipCode    : data.address?.zip_code   || '',
                            cityName   : data.address?.city_name  || '',
                            stateName  : data.address?.state_name || '',
                        },
                        weightLossGoal : data.weight_loss_goal || '',
                        ...(ef_transaction_id_get && { everflow_transaction_id: ef_transaction_id_get })
                    }
                };

                try {
                    const response = await fetch('https://api.humecare.com/v1/onboarding/patient-starter', {
                        method  : 'POST',
                        headers : {
                            'accept'      : 'application/json',
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(payload),
                    });

                    if (!response.ok) {
                        window.location.href = '/pages/quiz-funnel-4';
                        return;
                    }
                    const result = await response.json();
                    if (result.redirectUrl) {
                        localStorage.setItem('quiz_checkout_url', result.redirectUrl);
                        localStorage.removeItem('current_step');
                        window.location.href = result.redirectUrl;
                        return;
                    }
                    window.location.href = '/pages/quiz-funnel-4';

                } catch (err) {
                    sessionStorage.removeItem('patient_api_submitted');
                    console.error('Submission failed:', err);
                }
            }
        }

        initPatientSubmit();
    }

    // const checkoutUrl = localStorage.getItem('quiz_checkout_url');
    // if (checkoutUrl) {
    //     window.location.href = checkoutUrl;
    //     return;
    // }

    localStorage.removeItem('current_step');
})();

document.addEventListener('DOMContentLoaded', () => {
    let isFormSubmitting = false;
    let isClickingPac = false;
    const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;    
    const MIN_BMI    = 27;
    const steps      = document.querySelectorAll('.quiz__funnel__process');
    const savedIndex = localStorage.getItem('current_step');
    const startIndex = savedIndex !== null ? parseInt(savedIndex, 10) : 0;

    steps.forEach((step, i) => {
        if (i === startIndex) {
            step.classList.remove('hidden');
        } else {
            step.classList.add('hidden');
        }
    });

    const backBtn = document.querySelector('.columns__steps__back');
    if (startIndex > 0) {
        backBtn.classList.remove('hidden');
    } else {
        backBtn.classList.add('hidden');
    }

    const paginationContainer = document.querySelector('.quiz__funnel__columns___pagination');
    const paginationTrack     = document.createElement('div');
    paginationTrack.className = 'pagination__track';
    while (paginationContainer.firstChild) {
        paginationTrack.appendChild(paginationContainer.firstChild);
    }
    paginationContainer.appendChild(paginationTrack);

    const UNSUPPORTED_STATES = ['Alabama', 'Arkansas', 'Louisiana', 'Mississippi'];
    const FLORIDA_STATE      = 'Florida';

    const monthEl  = document.getElementById('dob__month');
    const dayEl    = document.getElementById('dob__day');
    const yearEl   = document.getElementById('dob__year');
    const errEl    = document.querySelector('.dob__error');
    if (!monthEl || !dayEl || !yearEl) return;

    const today    = new Date();
    const thisYear = today.getFullYear();
    const maxYear  = thisYear - 18;

    for (let y = maxYear; y >= thisYear - 120; y--) {
        const o = document.createElement('option');
        o.value = y; o.textContent = y;
        yearEl.appendChild(o);
    }

    function populateDays() {
        const m   = parseInt(monthEl.value) || 1;
        const y   = parseInt(yearEl.value)  || thisYear;
        const max = new Date(y, m, 0).getDate();
        const cur = dayEl.value;
        dayEl.innerHTML = '<option value="">Day</option>';
        for (let d = 1; d <= max; d++) {
            const v = String(d).padStart(2, '0');
            const o = document.createElement('option');
            o.value = v; o.textContent = d;
            if (v === cur) o.selected = true;
            dayEl.appendChild(o);
        }
    }

    function validateAndSave() {
        const m = monthEl.value;
        const d = dayEl.value;
        const y = yearEl.value;
        if (!m || !d || !y) return;

        const selected  = new Date(`${y}-${m}-${d}`);
        const midnight  = new Date();
        midnight.setHours(0, 0, 0, 0);

        if (selected > midnight) {
            if (errEl) { errEl.style.cssText = 'color: red; font-size: 13px; margin-bottom: 6px;'; errEl.textContent = 'Date of birth cannot be in the future.'; errEl.classList.remove('hidden'); }
            savePatientData('date_of_birth', null);
            return;
        }

        const minAge     = 18;
        const minAgeDate = new Date(midnight);
        minAgeDate.setFullYear(minAgeDate.getFullYear() - minAge);

        if (selected > minAgeDate) {
            if (errEl) { errEl.style.cssText = 'color: red; font-size: 13px; margin-bottom: 6px;'; errEl.textContent = `You must be at least ${minAge} years old to qualify for this program.`; errEl.classList.remove('hidden'); }
            savePatientData('date_of_birth', null);
            return;
        }        

        if (errEl) errEl.classList.add('hidden');
        savePatientData('date_of_birth', `${y}-${m}-${d}`);
    }

    const saved = getPatientData()?.date_of_birth;
    if (saved && /^\d{4}-\d{2}-\d{2}$/.test(saved)) {
        const [y, m, d] = saved.split('-');
        monthEl.value   = m;
        populateDays();
        dayEl.value     = d;
        yearEl.value    = y;
    } else {
        populateDays();
    }

    monthEl.addEventListener('change', () => { populateDays(); validateAndSave(); });
    dayEl.addEventListener('change',   validateAndSave);
    yearEl.addEventListener('change',  validateAndSave);


    function getPatientData() {
        return JSON.parse(localStorage.getItem('patient_starter') || '{}');
    }

    function savePatientData(key, value) {
        const data = getPatientData();
        const keys = key.split('.');
        if (keys.length === 2) {
            if (!data[keys[0]]) data[keys[0]] = {};
            data[keys[0]][keys[1]] = value;
        } else {
            data[key] = value;
        }
        const ordered = {
            first_name    : data.first_name    ?? null,
            last_name     : data.last_name     ?? null,
            email         : data.email         ?? null,
            date_of_birth : data.date_of_birth ?? null,
            gender        : data.gender        ?? null,
            weight        : data.weight        ?? null,
            height        : data.height        ?? null,
            phone_number : data.phone_number ?? null,
            address: {
                address      : data.address?.address      ?? null,
                address2     : data.address?.address2     ?? null,
                zip_code     : data.address?.zip_code     ?? null,
                city_name    : data.address?.city_name    ?? null,
                state_name   : data.address?.state_name   ?? null,
            },
            weight_loss_goal : data.weight_loss_goal ?? null,
        };
        localStorage.setItem('patient_starter', JSON.stringify(ordered));
    }

    function getTypedValue(input) {
        const type  = input.dataset.type;
        const value = input.value.trim();
        if (type === 'number') return Number(value);
        if (type === 'float')  return parseFloat(value);
        return value;
    }

    function formatDate(value) {
        if (!value) return '';
        if (/^\d{4}-\d{2}-\d{2}$/.test(value)) return value;
        const date = new Date(value);
        if (isNaN(date.getTime())) return '';
        const yyyy = date.getFullYear();
        const mm   = String(date.getMonth() + 1).padStart(2, '0');
        const dd   = String(date.getDate()).padStart(2, '0');
        return `${yyyy}-${mm}-${dd}`;
    }

    function saveCurrentStep() {
        const currentStep = document.querySelector('.quiz__funnel__process:not(.hidden)');
        const index       = Array.from(steps).indexOf(currentStep);
        localStorage.setItem('current_step', index);
    }

    function clearCurrentStep() {
        localStorage.removeItem('current_step');
    }

    function showError(parent, message) {
        const existing = parent.querySelector('.process__error__msg');
        if (existing) existing.remove();
        const msg = document.createElement('p');
        msg.classList.add('process__error__msg');
        msg.style.cssText = 'color: red; font-size: 13px; margin-bottom: 6px;';
        msg.textContent = message;
        const optionsEl = parent.querySelector('.quiz__funnel__process_options');
        if (optionsEl) {
            optionsEl.insertAdjacentElement('beforebegin', msg);
        } else {
            parent.prepend(msg);
        }
    }

    function removeError(parent) {
        const msg = parent.querySelector('.process__error__msg');
        if (msg) msg.remove();
    }

    let isFirstLoad = true;

    function fireStepPixel(stepName) {
        if (typeof window === 'undefined') return;
        const fn = window.cvg ?? (typeof cvg !== 'undefined' ? cvg : undefined);
        if (typeof fn !== 'function') return;
        fn({ method: 'set',   eventProperties: { page_title: stepName } });
        fn({ method: 'track', eventName: '$page_load', properties: { page_title: stepName } });
    }

    function updatePagination() {
        const dots = document.querySelectorAll(
            '.quiz__funnel__columns___pagination span'
        );
        const container = document.querySelector(
            '.quiz__funnel__columns___pagination'
        );
        const track = document.querySelector('.pagination__track');
        const currentStep = document.querySelector(
            '.quiz__funnel__process:not(.hidden)'
        );
        const index = Array.from(steps).indexOf(currentStep);

        dots.forEach((dot, i) => {
            dot.classList.remove('active', 'completed');

            if (i === index) {
                dot.classList.add('active');
            }

            if (i < index) {
                dot.classList.add('completed');
            }
        });

        const isMobile = window.innerWidth <= 768;

        if (isMobile) {
            container.style.overflow = 'hidden';

            const activeDot = dots[index];

            if (activeDot && track) {
                const containerWidth = container.offsetWidth;
                const trackWidth = track.scrollWidth;

                const containerCenter = containerWidth / 2;
                const dotCenter =
                    activeDot.offsetLeft + activeDot.offsetWidth / 2;

                let translateX = containerCenter - dotCenter;

                const minTranslate = Math.min(0, containerWidth - trackWidth);
                const maxTranslate = 0;

                translateX = Math.max(
                    minTranslate,
                    Math.min(maxTranslate, translateX)
                );

                track.style.transform = `translateX(${translateX}px)`;
            }
        } else {
            container.style.overflow = 'visible';
            track.style.transform = 'translateX(0)';
        }

        if (isFirstLoad) {
            isFirstLoad = false;
            return;
        }

        const stepName = currentStep?.dataset.step || `step_${index}`;
        fireStepPixel(stepName);
    }

    function calculateBMI() {
        const data         = getPatientData();
        const weightLbs    = data.weight;
        const heightInches = data.height;
        if (!weightLbs || !heightInches || heightInches === 0) return null;
        const bmi = (weightLbs * 703) / (heightInches * heightInches);
        return parseFloat(bmi.toFixed(1));
    }

    function validateBMI(currentFlow) {
        const bmi  = calculateBMI();
        const data = getPatientData();
        if (!data.weight || !data.height) return true;
        if (bmi === null) return true;
        const nextBtn     = currentFlow.querySelector('.process__button__txt');
        const weightGroup = currentFlow.querySelector('input[name="weight"]')?.closest('.inputtext__group');
        const heightGroup = currentFlow.querySelector('[data-group="height"]');
        const targetGroup = weightGroup || heightGroup;
        if (bmi < MIN_BMI) {
            const errMsg = `Based on your height and weight, your BMI is ${bmi}. Our program requires a BMI of ${MIN_BMI} or higher to be eligible.`;
            if (targetGroup) showError(targetGroup, errMsg);
            if (nextBtn) {
                nextBtn.style.pointerEvents = 'none';
                nextBtn.style.opacity       = '0.5';
            }
            return false;
        }
        if (weightGroup) removeError(weightGroup);
        if (heightGroup) removeError(heightGroup);
        if (nextBtn) {
            nextBtn.style.pointerEvents = '';
            nextBtn.style.opacity       = '';
        }
        return true;
    }

    function checkAndScrollToButton(currentFlow) {
        let allFilled         = true;
        const hasOptionsLabel = currentFlow.querySelectorAll('.process_options__label').length > 0;
        const hasTextInputs   = currentFlow.querySelectorAll('.inputtext__group').length > 0;
        const hasRadioGroup   = currentFlow.querySelectorAll('.inputradio__group').length > 0;

        if (hasOptionsLabel) {
            const checked = currentFlow.querySelector('.process_options__label input:checked');
            if (!checked) allFilled = false;
        }

        if (hasTextInputs) {
            currentFlow.querySelectorAll('.inputtext__group').forEach((group) => {
                if (group.dataset.group === 'height') {
                    const ft = group.querySelector('[data-unit="ft"]');
                    if (!ft || !ft.value.trim()) allFilled = false;
                    return;
                }
                group.querySelectorAll('input, textarea').forEach((input) => {
                    if (input.name === 'zip_code') return;
                    if (!input.value.trim()) allFilled = false;
                });
                group.querySelectorAll('select').forEach((select) => {
                    if (!select.value) allFilled = false;
                });
            });
        }

        if (hasRadioGroup) {
            currentFlow.querySelectorAll('.inputradio__group').forEach((group) => {
                const checked = group.querySelector('input[type="radio"]:checked');
                if (!checked) allFilled = false;
            });
        }

        if (allFilled) {
            const btn = currentFlow.querySelector('.quiz__funnel__process__button');
            if (btn) btn.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }

    function validatePhone(input) {
        const group      = input.closest('.inputtext__group') || input.parentElement;
        const cleanPhone = input.value.replace(/\D/g, '');
        if (cleanPhone.length > 0 && cleanPhone.length !== 10) {
            showError(group, 'Please enter a valid 10-digit US phone number.');
            return false;
        } else {
            removeError(group);
            return true;
        }
    }

    function handleStateLogic(state, zip) {
        const floridaBox  = document.getElementById('florida__checkbox');
        const stateErrMsg = document.getElementById('state__error__msg');
        const nextBtn     = floridaBox?.closest('.step____fifteen')?.querySelector('.process__button__txt');

        floridaBox?.classList.add('hidden');
        stateErrMsg?.classList.add('hidden');
        if (stateErrMsg) stateErrMsg.textContent = '';
        if (nextBtn) {
            nextBtn.style.pointerEvents = '';
            nextBtn.style.opacity       = '';
        }

        if (!state || !state.trim()) return;

        const normalizedState = state.trim().toLowerCase();
        const isUnsupported   = UNSUPPORTED_STATES.some(s => s.toLowerCase() === normalizedState);

        if (isUnsupported) {
            if (stateErrMsg) {
                stateErrMsg.textContent = `We're sorry, we don't currently service ${state}. Please check back soon.`;
                stateErrMsg.classList.remove('hidden');
            }
            if (nextBtn) {
                nextBtn.style.pointerEvents = 'none';
                nextBtn.style.opacity       = '0.5';
            }
            return;
        }

        if (normalizedState === FLORIDA_STATE.toLowerCase()) {
            floridaBox?.classList.remove('hidden');
        }
    }

    function validateName(input) {
        const group = input.closest('.inputtext__group') || input.parentElement;
        const value = input.value.trim();
        if (!value) {
            showError(group, 'This field is required.');
            return false;
        }
        if (!/^[\p{L}\s\-'\.]+$/u.test(value)) {
            showError(group, 'Please enter a valid name.');
            return false;
        }
        if (value.length < 2) {
            showError(group, 'Name must be at least 2 characters.');
            return false;
        }
        removeError(group);
        return true;
    }

    function validateZip(input) {
        const group = input.closest('.inputtext__group') || input.parentElement;
        const value = input.value.trim();
        if (!value) {
            showError(group, 'Zip code is required.');
            return false;
        }
        if (!/^\d{5}(-\d{4})?$/.test(value)) {
            showError(group, 'Please enter a valid US zip code (e.g. 80247).');
            return false;
        }
        removeError(group);
        return true;
    }    

    function validateEmail(input) {
        const group = input.closest('.inputtext__group') || input.parentElement;
        const value = input.value.trim();
        if (!value) {
            showError(group, 'This field is required.');
            return false;
        }
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
            showError(group, 'Please enter a valid email address.');
            return false;
        }
        removeError(group);
        return true;
    }

    function initAddressAutocomplete() {
        const input    = document.getElementById('ctrl__autocomplete');
        const suggList = document.getElementById('address__suggestions');

        if (!input || !suggList || typeof google === 'undefined') return;

        input.setAttribute('autocomplete',   'off');
        input.setAttribute('autocorrect',    'off');
        input.setAttribute('autocapitalize', 'off');
        input.setAttribute('spellcheck',     'false');

        const { AutocompleteService, PlacesService } = google.maps.places;
        const autocompleteService = new AutocompleteService();
        const placesService       = new PlacesService(document.createElement('div'));
        
        let   sessionToken        = new google.maps.places.AutocompleteSessionToken();
        let   activeSuggIndex     = -1;
        let   debounceTimer;
        let   currentPredictions  = []; 

        function clearSuggestions() {
            suggList.innerHTML     = '';
            suggList.style.display = 'none';
            activeSuggIndex        = -1;
            currentPredictions     = [];
        }

        function fillAddress(place) {
            if (!place || !place.address_components) return;

            let streetNumber = '';
            let route        = '';
            let city         = '';
            let state        = '';
            let zip          = '';
            let country      = '';

            place.address_components.forEach((component) => {
                const type = component.types[0];
                if (type === 'street_number')           streetNumber = component.long_name;
                if (type === 'route')                   route        = component.long_name;
                if (type === 'locality')                city         = component.long_name;
                if (type === 'administrative_area_level_1') state    = component.long_name;
                if (type === 'postal_code')             zip          = component.long_name;
                if (type === 'country')                 country      = component.short_name;
            });

            const group = input.closest('.inputtext__group') || input.parentElement;

            if (country !== 'US') {
                input.value = '';
                if (typeof showError === 'function') showError(group, 'Please enter a US address only.');
                return;
            }

            input.value = `${streetNumber} ${route}`.trim();

            const cityEl = document.querySelector('[name="city_name"]');
            const zipEl  = document.querySelector('[name="zip_code"]');
            if (cityEl) cityEl.value = city;
            if (zipEl)  zipEl.value  = zip;

            const stateSelect = document.getElementById('address__state');
            if (stateSelect) {
                const match = Array.from(stateSelect.options)
                    .find(opt => opt.value.toLowerCase() === state.toLowerCase());
                stateSelect.value = match ? state : '';
            }

            if (typeof savePatientData === 'function') {
                savePatientData('address.address',    input.value);
                savePatientData('address.city_name',  city);
                savePatientData('address.zip_code',   zip);
                savePatientData('address.state_name', state);
            }

            if (typeof handleStateLogic === 'function') handleStateLogic(state, zip);
            if (typeof removeError === 'function') removeError(group);
        }

        function selectPrediction(prediction) {
            if (!prediction) return;
            input.value = prediction.description;
            clearSuggestions();
            
            sessionToken = new google.maps.places.AutocompleteSessionToken();

            placesService.getDetails(
                { 
                    placeId: prediction.place_id, 
                    fields: ['address_components'],
                    sessionToken: sessionToken
                },
                (place, status) => {
                    if (status !== 'OK' || !place) {
                        console.warn('getDetails failed:', status);
                        return;
                    }
                    fillAddress(place);
                }
            );
        }

        function renderSuggestions(predictions) {
            clearSuggestions();
            if (!predictions || predictions.length === 0) return;

            currentPredictions = predictions; 

            predictions.forEach((prediction) => {
                const li = document.createElement('li');
                li.classList.add('address__suggestion__item');
                li.style.cursor = 'pointer'; 

                const main = document.createElement('span');
                main.classList.add('suggestion__main');
                main.textContent = prediction.structured_formatting?.main_text || prediction.description;

                const secondary = document.createElement('span');
                secondary.classList.add('suggestion__secondary');
                secondary.textContent = prediction.structured_formatting?.secondary_text || '';

                li.appendChild(main);
                li.appendChild(secondary);

                li.addEventListener('click', () => {
                    selectPrediction(prediction);
                });

                suggList.appendChild(li);
            });

            suggList.style.display = 'block';
        }

        input.addEventListener('keydown', (e) => {
            const items = suggList.querySelectorAll('.address__suggestion__item');
            if (!items.length) return;

            if (e.key === 'ArrowDown') {
                e.preventDefault();
                activeSuggIndex = Math.min(activeSuggIndex + 1, items.length - 1);
                items.forEach((item, i) => item.classList.toggle('active', i === activeSuggIndex));
            } else if (e.key === 'ArrowUp') {
                e.preventDefault();
                activeSuggIndex = Math.max(activeSuggIndex - 1, 0);
                items.forEach((item, i) => item.classList.toggle('active', i === activeSuggIndex));
            } else if (e.key === 'Enter') {
                e.preventDefault();
                if (activeSuggIndex >= 0 && currentPredictions[activeSuggIndex]) {
                    selectPrediction(currentPredictions[activeSuggIndex]);
                }
            } else if (e.key === 'Escape') {
                clearSuggestions();
            }
        });

        input.addEventListener('input', () => {
            const group = input.closest('.inputtext__group') || input.parentElement;
            if (typeof removeError === 'function') removeError(group);
            
            clearTimeout(debounceTimer);
            const val = input.value.trim();
            if (val.length < 3) { clearSuggestions(); return; }

            debounceTimer = setTimeout(() => {
                autocompleteService.getPlacePredictions(
                    {
                        input                : val,
                        sessionToken         : sessionToken,
                        componentRestrictions: { country: 'us' },
                        types                : ['address'],
                    },
                    (predictions, status) => {
                        if (status !== 'OK' || !predictions) { 
                            clearSuggestions(); 
                            return; 
                        }
                        renderSuggestions(predictions);
                    }
                );
            }, 250);
        });

        document.addEventListener('click', (e) => {
            if (!input.contains(e.target) && !suggList.contains(e.target)) {
                clearSuggestions();
                const stateSelect = document.getElementById('address__state');
                const group       = input.closest('.inputtext__group') || input.parentElement;
                if (input.value.trim() && (!stateSelect || !stateSelect.value)) {
                    if (typeof showError === 'function') {
                        showError(group, 'Please select an address from the suggestions.');
                    }
                }
            }
        });

        input.addEventListener('focus', () => {
            if (input.value.trim().length >= 3) {
                input.dispatchEvent(new Event('input'));
            }
        });
    }

    function getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
    }
        
    async function submitPatientData() {
        const data          = getPatientData();
        const payload = {
            programCode   : 'glp1',
            offer         : 4,
            patientStarter: {
                firstName               : data.first_name    || '',
                lastName                : data.last_name     || '',
                email                   : data.email         || '',
                dateOfBirth             : formatDate(data.date_of_birth),
                gender                  : data.gender        ?? null,
                weight                  : data.weight        ?? null,
                height                  : data.height        ?? null,
                address: {
                    address             : data.address?.address    || '',
                    address2            : data.address?.address2   || '',
                    zipCode             : data.address?.zip_code   || '',
                    cityName            : data.address?.city_name  || '',
                    stateName           : data.address?.state_name || '',
                },
                weightLossGoal          : data.weight_loss_goal    || '',
                ...(ef_transaction_id_get && { everflow_transaction_id: ef_transaction_id_get })
            }
        };

        try {
            const response = await fetch('https://api.humecare.com/v1/onboarding/patient-starter', {
                method  : 'POST',
                headers : {
                    'accept'      : 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload),
            });

            if (!response.ok) {
                const error = await response.json().catch(() => null);
                console.log('API error:', JSON.stringify(error?.details, null, 2));
                throw new Error(error?.message || `Server error: ${response.status}`);
            }

            const result = await response.json();

            if (result.redirectUrl) {
                localStorage.setItem('quiz_checkout_url', result.redirectUrl);
                localStorage.removeItem('current_step');
                return { success: true, redirectUrl: result.redirectUrl };
            }

            return { success: true, redirectUrl: '/' };

        } catch (err) {
            console.error('Submission failed:', err);
            return { success: false, redirectUrl: null };
        }
    }

    const initialStep = document.querySelector('.quiz__funnel__process:not(.hidden)');
    fireStepPixel(initialStep?.dataset.step || 'step_0');

    const bmiOnLoad = calculateBMI();
    if (bmiOnLoad !== null) {
        const weightStep = document.querySelector('input[name="weight"]')?.closest('.quiz__funnel__process');
        const heightStep = document.querySelector('[data-group="height"]')?.closest('.quiz__funnel__process');
        if (weightStep) validateBMI(weightStep);
        if (heightStep && heightStep !== weightStep) validateBMI(heightStep);
    }

    const firstNameInput = document.querySelector('input[name="first_name"]');
    if (firstNameInput) {
        firstNameInput.addEventListener('input', () => {
            firstNameInput.value = firstNameInput.value.replace(/[0-9]/g, '');
            savePatientData('first_name', firstNameInput.value.trim());
        });
        firstNameInput.addEventListener('blur', () => {
            validateName(firstNameInput);
        });
    }
    const lastNameInput = document.querySelector('input[name="last_name"]');
    if (lastNameInput) {
        lastNameInput.addEventListener('input', () => {
            lastNameInput.value = lastNameInput.value.replace(/[0-9]/g, '');
            savePatientData('last_name', lastNameInput.value.trim());
        });
        lastNameInput.addEventListener('blur', () => validateName(lastNameInput));
    }

    const emailInput = document.querySelector('input[name="email"]');
    if (emailInput) {
        emailInput.addEventListener('input', () => {
            savePatientData('email', emailInput.value.trim());
            if (emailInput.value.trim()) removeError(emailInput.closest('.inputtext__group') || emailInput.parentElement);
        });
        emailInput.addEventListener('blur', () => validateEmail(emailInput));
    }
    
    const zipInput = document.querySelector('[name="zip_code"]');
    if (zipInput) {
        zipInput.addEventListener('input', () => {
            let value = zipInput.value.replace(/\D/g, '');
            zipInput.value = value.substring(0, 5);
            if (!zipInput.value.trim()) {
                removeError(zipInput.closest('.inputtext__group') || zipInput.parentElement);
                savePatientData('address.zip_code', '');
            }
        });

        zipInput.addEventListener('blur', () => {
            const zipValue = zipInput.value.trim();
            const usFiveDigitRegex = /^\d{5}$/;
            if (zipValue === '') {
                return;
            }
            if (usFiveDigitRegex.test(zipValue)) {
                removeError(zipInput.closest('.inputtext__group') || zipInput.parentElement);
                savePatientData('address.zip_code', zipValue);
            } else {
                if (typeof validateZip === 'function') {
                    validateZip(zipInput);
                } else {
                    const group = zipInput.closest('.inputtext__group') || zipInput.parentElement;
                    showError(group, 'Please enter a valid 5-digit US ZIP code.');
                }
            }
        });
    }

    // document.querySelectorAll('[data-group="height"] input').forEach((input) => {
    //     const data  = getPatientData();
    //     const saved = data.height;
    //     if (saved && typeof saved === 'number') {
    //         const ft     = Math.floor(saved / 12);
    //         const inches = Math.round(saved % 12);
    //         input.value  = input.dataset.unit === 'ft' ? (ft || '') : (inches || '');
    //     }
    // });

    const restoredState = getPatientData()?.address?.state_name;
    const restoredZip   = getPatientData()?.address?.zip_code;
    if (restoredState) {
        const stateSelect = document.getElementById('address__state');
        if (stateSelect) stateSelect.value = restoredState;
        handleStateLogic(restoredState, restoredZip);
    }

    initAddressAutocomplete();

    document.getElementById('address__zip')?.addEventListener('blur', () => {
        const state = document.getElementById('address__state')?.value;
        const zip   = document.getElementById('address__zip')?.value;
        if (state) handleStateLogic(state, zip);
    });

    document.getElementById('address__state')?.addEventListener('change', function () {
        const state       = this.value;
        savePatientData('address.state_name', state);
        const floridaCheckbox = document.getElementById('florida__checkbox');
        if (floridaCheckbox) {
            if (state === 'FL' || state === 'Florida') {
                floridaCheckbox.classList.remove('hidden');
            } else {
                floridaCheckbox.classList.add('hidden');
            }
        }        
    });

    document.querySelectorAll('input[type="date"]').forEach((input) => {
        const today = new Date().toISOString().split('T')[0];
        input.setAttribute('max', today);

        const openPicker = function () {
            try { this.showPicker(); } catch (e) {}
        };
        input.addEventListener('click', openPicker);
        input.addEventListener('focus', openPicker);

        const validateDate = function () {
            if (!this.value) return;
            const selected = new Date(this.value);
            const now      = new Date();
            now.setHours(0, 0, 0, 0);
            if (selected > now) {
                this.value = '';
                const group = this.closest('.inputtext__group') || this.parentElement;
                showError(group, 'Date of birth cannot be in the future.');
            } else {
                const group = this.closest('.inputtext__group') || this.parentElement;
                removeError(group);
                const key = this.dataset.save;
                if (key) savePatientData(key, this.value);
            }
        };
        input.addEventListener('change', validateDate);
        input.addEventListener('blur',   validateDate);
    });

    document.querySelectorAll('[data-group="height"] input').forEach((input) => {
        input.addEventListener('input', () => {
            const group       = input.closest('[data-group="height"]');
            const ft          = Number(group.querySelector('[data-unit="ft"]').value.trim()) || 0;
            const inches      = Number(group.querySelector('[data-unit="in"]').value.trim()) || 0;
            const totalInches = (ft * 12) + inches;
            savePatientData('height', totalInches);
            if (ft || inches) removeError(group);
            const currentFlow = input.closest('.quiz__funnel__process');
            if (currentFlow) checkAndScrollToButton(currentFlow);
        });

        input.addEventListener('blur', () => {
            const group = input.closest('[data-group="height"]');

            if (input.dataset.unit === 'ft') {
                const val = Number(input.value);
                if (input.value && val < 4) {
                    showError(group, 'Please enter a valid height. Feet must be at least 4.');
                    input.value = '';
                    savePatientData('height', null);
                    return;
                }
            }

            if (input.dataset.unit === 'in') {
                const val = Number(input.value);
                if (input.value && val > 11) {
                    showError(group, 'Inches must be between 0 and 11.');
                    input.value = '';
                    savePatientData('height', null);
                    return;
                }
            }

            const currentFlow = input.closest('.quiz__funnel__process');
            if (currentFlow) validateBMI(currentFlow);
        });
    });

    document.querySelectorAll('.inputtext__group').forEach((group) => {
        group.querySelectorAll('input, textarea').forEach((input) => {
            if (input.dataset.unit) return;

            input.addEventListener('input', () => {
                const key = input.dataset.save;
                if (key) savePatientData(key, getTypedValue(input));
                if (input.value.trim()) removeError(group);
            });

            input.addEventListener('blur', () => {
                const currentFlow = input.closest('.quiz__funnel__process');
                if (currentFlow) checkAndScrollToButton(currentFlow);
            });
        });
    });

    document.querySelectorAll('.process_options__label input').forEach((input) => {
        input.addEventListener('change', () => {
            const key = input.dataset.save;
            if (key) savePatientData(key, getTypedValue(input));
            const parent = input.closest('.quiz__funnel__process');
            if (parent) {
                removeError(parent);
                checkAndScrollToButton(parent);
            }
        });
    });

    document.querySelectorAll('.inputradio__group input[type="radio"]').forEach((radio) => {
        radio.addEventListener('change', () => {
            const key = radio.dataset.save;
            if (key) savePatientData(key, getTypedValue(radio));
            const group = radio.closest('.inputradio__group');
            if (group) removeError(group);
            const currentFlow = radio.closest('.quiz__funnel__process');
            if (currentFlow) checkAndScrollToButton(currentFlow);
        });
    });

    document.querySelectorAll('[name="phone_number"]').forEach((input) => {
        input.addEventListener('input', (e) => {
            let value = e.target.value.replace(/\D/g, '').substring(0, 10);
            let formatted = '';
            if (value.length > 0) formatted  = '(' + value.substring(0, 3);
            if (value.length > 3) formatted  += ') ' + value.substring(3, 6);
            if (value.length > 6) formatted  += '-' + value.substring(6, 10);
            e.target.value = formatted;
            const key = input.dataset.save;
            if (key) savePatientData(key, value);
            validatePhone(input);
        });

        if (input.value.trim() !== '') validatePhone(input);
    });

    const weightInput = document.querySelector('input[name="weight"]');
    if (weightInput) {
        weightInput.addEventListener('blur', () => {
            const val         = Number(weightInput.value);
            const group       = weightInput.closest('.inputtext__group') || weightInput.parentElement;
            const currentFlow = weightInput.closest('.quiz__funnel__process');
            if (weightInput.value && val < 99) {
                showError(group, 'Please enter a valid weight. Minimum is 99 lbs.');
                weightInput.value = '';
                savePatientData('weight', null);
                return;
            }
            if (weightInput.value && val > 600) {
                showError(group, 'Please enter a valid weight. Maximum is 600 lbs.');
                weightInput.value = '';
                savePatientData('weight', null);
                return;
            }
            if (currentFlow) validateBMI(currentFlow);
        });
    }

    document.querySelectorAll('[js-process-next-vw]').forEach((button) => {
        button.addEventListener('click', async (tg) => {
            tg.preventDefault();
            const currentFlow = tg.currentTarget.closest('.quiz__funnel__process');
            const nextFlow    = currentFlow.nextElementSibling;

            if (!nextFlow && isFormSubmitting) return;

            let isValid = true;

            if (currentFlow.querySelectorAll('.process_options__label').length > 0) {
                const checked = currentFlow.querySelector('.process_options__label input:checked');
                if (!checked) {
                    showError(currentFlow, 'Please select an option before continuing.');
                    isValid = false;
                } else {
                    removeError(currentFlow);
                }
            }

            currentFlow.querySelectorAll('.inputtext__group').forEach((group) => {
                if (group.dataset.group === 'height') {
                    const ft = group.querySelector('[data-unit="ft"]');
                    if (!ft || !ft.value.trim()) {
                        showError(group, 'Please enter your height.');
                        isValid = false;
                    } else {
                        removeError(group);
                    }
                    return;
                }

                group.querySelectorAll('input, textarea').forEach((input) => {
                    if (['first_name', 'last_name', 'email', 'address2'].includes(input.name)) return;
                    if (input.offsetWidth > 0 && input.offsetHeight > 0 && !input.value.trim()) {
                        showError(group, 'This field is required.');
                        isValid = false;
                    } else if (input.offsetWidth > 0) {
                        removeError(group);
                    }
                });

                group.querySelectorAll('select').forEach((select) => {
                    if (select.offsetWidth > 0 && select.offsetHeight > 0 && !select.value) {
                        showError(group, 'This field is required.');
                        isValid = false;
                    } else if (select.offsetWidth > 0) {
                        removeError(group);
                    }
                });
            });

            const firstNameEl = currentFlow.querySelector('input[name="first_name"]');
            const lastNameEl  = currentFlow.querySelector('input[name="last_name"]');
            const emailEl     = currentFlow.querySelector('input[name="email"]');

            if (firstNameEl && firstNameEl.offsetWidth > 0 && !validateName(firstNameEl)) isValid = false;
            if (lastNameEl  && lastNameEl.offsetWidth > 0  && !validateName(lastNameEl))  isValid = false;
            if (emailEl     && emailEl.offsetWidth > 0     && !validateEmail(emailEl))    isValid = false;
                        
            currentFlow.querySelectorAll('.inputradio__group').forEach((group) => {
                const checked = group.querySelector('input[type="radio"]:checked');
                if (!checked) {
                    showError(group, 'Please select one of the options.');
                    isValid = false;
                } else {
                    removeError(group);
                }
            });

            if( currentFlow.querySelector('input[name="weight"]') ){
                const bmi = calculateBMI();
                if (bmi !== null && bmi < MIN_BMI) {
                    const weightGroup = currentFlow.querySelector('input[name="weight"]')?.closest('.inputtext__group');
                    const heightGroup = currentFlow.querySelector('[data-group="height"]');
                    const targetGroup = weightGroup || heightGroup;
                    if (targetGroup) {
                        showError(targetGroup, `Your BMI is ${bmi}. Our program requires a BMI of ${MIN_BMI} or higher to be eligible.`);
                    }
                    isValid = false;
                }
            }

            const dobMonth = document.getElementById('dob__month')?.value;
            const dobDay   = document.getElementById('dob__day')?.value;
            const dobYear  = document.getElementById('dob__year')?.value;
            const dobGroup = currentFlow.querySelector('[data-group="dob"]');
            if (dobGroup && dobGroup.offsetWidth > 0) {
                if (!dobMonth || !dobDay || !dobYear) {
                    showError(dobGroup, 'Please enter your date of birth.');
                    isValid = false;
                } else {
                    removeError(dobGroup);
                }
            }

            if (currentFlow.classList.contains('step____fifteen')) {
                const phoneInput = currentFlow.querySelector('[name="phone_number"]');
                if (phoneInput && phoneInput.offsetWidth > 0 && !validatePhone(phoneInput)) {
                    isValid = false;
                }

                const floridaBox      = document.getElementById('florida__checkbox');
                const floridaCheckbox = document.getElementById('accept__right_reserved');
                if (floridaBox && !floridaBox.classList.contains('hidden')) {
                    if (!floridaCheckbox || !floridaCheckbox.checked) {
                        showError(floridaBox, 'Please confirm you have reviewed the Florida Bill of Rights.');
                        isValid = false;
                    } else {
                        removeError(floridaBox);
                    }
                }

                const stateErrMsg = document.getElementById('state__error__msg');
                if (stateErrMsg && !stateErrMsg.classList.contains('hidden')) {
                    isValid = false;
                }
            }

            if (!isValid) {
                const firstError = currentFlow.querySelector('.process__error__msg') ||
                                currentFlow.querySelector('#state__error__msg:not(.hidden)');
                if (firstError) {
                    firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
                return;
            }


            if (nextFlow) {
                currentFlow.classList.add('hidden');
                nextFlow.classList.remove('hidden');
                backBtn.classList.remove('hidden');
                updatePagination();
                window.scrollTo({ top: 0, behavior: 'smooth' });
                saveCurrentStep();
            }
        });
    });

    let isFormSubmittingfnl = false;
    document.querySelectorAll('[js-process-next-fnl]').forEach((button) => {
        button.addEventListener('pointerdown', async (tg) => {
            tg.preventDefault();
            if (isFormSubmittingfnl) return;
            if (document.activeElement && ['INPUT', 'TEXTAREA', 'SELECT'].includes(document.activeElement.tagName)) {
                document.activeElement.blur();
            }
            const currentFlowFnl = tg.currentTarget.closest('.quiz__funnel__process');
            let isValid = true;
            currentFlowFnl.querySelectorAll('.inputtext__group').forEach((group) => {
                group.querySelectorAll('input, textarea').forEach((input) => {
                    if (['first_name', 'last_name', 'email', 'address2'].includes(input.name)) return;
                    if (input.offsetWidth > 0 && input.offsetHeight > 0 && !input.value.trim()) {
                        showError(group, 'This field is required.');
                        isValid = false;
                    } else if (input.offsetWidth > 0) {
                        removeError(group);
                    }
                });
                group.querySelectorAll('select').forEach((select) => {
                    if (select.offsetWidth > 0 && select.offsetHeight > 0 && !select.value) {
                        showError(group, 'This field is required.');
                        isValid = false;
                    } else if (select.offsetWidth > 0) {
                        removeError(group);
                    }
                });
            });
            const phoneInput = currentFlowFnl.querySelector('[name="phone_number"]');
            if (phoneInput && phoneInput.offsetWidth > 0 && !validatePhone(phoneInput)) {
                isValid = false;
            }

            const zipEl = currentFlowFnl.querySelector('[name="zip_code"]');
            if (zipEl && zipEl.offsetWidth > 0) {
                if (!validateZip(zipEl)) isValid = false;
            }

            const floridaBox      = document.getElementById('florida__checkbox');
            const floridaCheckbox = document.getElementById('accept__right_reserved');
            if (floridaBox && !floridaBox.classList.contains('hidden')) {
                if (!floridaCheckbox || !floridaCheckbox.checked) {
                    showError(floridaBox, 'Please confirm you have reviewed the Florida Bill of Rights.');
                    isValid = false;
                } else {
                    removeError(floridaBox);
                }
            }
            const stateErrMsg = document.getElementById('state__error__msg');
            if (stateErrMsg && !stateErrMsg.classList.contains('hidden')) {
                isValid = false;
            }
            if (isValid) {
                isFormSubmittingfnl = true;
                const btn = tg.currentTarget;
                btn.closest('.quiz__funnel__process__button').classList.add('loading');
                btn.style.pointerEvents = 'none';
                try {
                    const result = await submitPatientData();
                    if (result.success) {
                        btn.closest('.quiz__funnel__process__button').classList.remove('loading');
                        btn.querySelector('.txt__process_wp__b').textContent = 'Ready!';
                        window.location.href = result.redirectUrl;
                    } else {
                        btn.closest('.quiz__funnel__process__button').classList.remove('loading');
                        btn.querySelector('.txt__process_wp__b').textContent = 'Show me my program';
                        showError(currentFlowFnl, 'Something went wrong. Please try again.');
                        btn.style.pointerEvents = 'auto';
                        isFormSubmittingfnl = false; 
                    }
                } catch (err) {
                    isFormSubmittingfnl = false;
                    btn.style.pointerEvents = 'auto';
                    btn.closest('.quiz__funnel__process__button').classList.remove('loading');
                }  
            }              
        });
    });

    document.querySelector('.columns__steps__back').addEventListener('click', () => {
        const currentFlow = document.querySelector('.quiz__funnel__process:not(.hidden)');
        const prevFlow    = currentFlow.previousElementSibling;
        if (prevFlow && prevFlow.classList.contains('quiz__funnel__process')) {
            currentFlow.querySelectorAll('.process__error__msg').forEach(msg => msg.remove());
            currentFlow.classList.add('hidden');
            prevFlow.classList.remove('hidden');
        }
        const newCurrent = document.querySelector('.quiz__funnel__process:not(.hidden)');
        const isFirst    = !newCurrent.previousElementSibling ||
                           !newCurrent.previousElementSibling.classList.contains('quiz__funnel__process');
        backBtn.classList.toggle('hidden', isFirst);
        saveCurrentStep();
        updatePagination();
        window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    document.querySelectorAll('.process_medication__med-card').forEach((tb) => {
        tb.addEventListener('click', (tg) => {
            tg.preventDefault();
            const bodyScrollHeight = tg.currentTarget.querySelector('.process_medication__detail-body').scrollHeight;
            if (tg.currentTarget.classList.contains('active')) {
                tg.currentTarget.querySelector('.process_medication__detail-body').style.maxHeight = null;
                tg.currentTarget.classList.remove('active');
                tg.currentTarget.querySelector('.process_medication__plus-btn').innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none"><mask id="mask0_1419_1000" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="17" height="17"><rect width="16.4756" height="16.4756" fill="#D9D9D9"></rect></mask><g mask="url(#mask0_1419_1000)"><path d="M7.55143 14.4163V8.9244H2.05957V7.55143H7.55143V2.05957H8.9244V7.55143H14.4163V8.9244H8.9244V14.4163H7.55143Z" fill="white"></path></g></svg>`;
            } else {
                tg.currentTarget.querySelector('.process_medication__detail-body').style.maxHeight = `${bodyScrollHeight}px`;
                tg.currentTarget.classList.add('active');
                tg.currentTarget.querySelector('.process_medication__plus-btn').innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="10" height="2" viewBox="0 0 10 2" fill="none"><path d="M0 1.37297V0H9.61076V1.37297H0Z" fill="white"/></svg>`;
            }
        });
    });

    updatePagination();
    document.querySelectorAll('input[name="gender"]').forEach(function(radio) {
        radio.addEventListener('click', function() {
            savePatientData('gender', parseInt(this.value));
        var genderName = this.value === '1' ? 'male' : 'female';
        console.log('Gender selected:', genderName);
            var allSteps = document.querySelectorAll('.quiz__funnel__process');
            var currentFlow = document.querySelector('.quiz__funnel__process:not(.hidden)');
            var currentIndex = Array.from(allSteps).indexOf(currentFlow);
            var nextFlow = allSteps[currentIndex + 1];

            (function(cf, nf) {
                setTimeout(function() {
                    if (nf) {
                        cf.classList.add('hidden');
                        nf.classList.remove('hidden');
                        backBtn.classList.remove('hidden');
                        saveCurrentStep();
                        updatePagination();
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                    }
                }, 300);
            })(currentFlow, nextFlow);
        });
    });

    const days   = 30;
    const params = new URLSearchParams(window.location.search);
    const discount = params.get('discount');
    if (discount) {
        const expires = new Date();
        expires.setDate(expires.getDate() + days);
        document.cookie = `hc_campaign=${encodeURIComponent(discount)}; expires=${expires.toUTCString()}; path=/; SameSite=Lax`;
    }

});